module.exports = __webpack_public_path__ + "img/check-circle.2a66e197.svg";